module.exports = __webpack_public_path__ + "media/components/src/assets/images/logo/check-2976b0c9494a4840ef676b858a5d4249.svg";